import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSubscription } from '../../hooks/useSubscription';
import LoadingSpinner from './LoadingSpinner';

const SubscriptionGate = ({
  children,
  requireSubscription = true,
  redirectIfSubscribedTo = '/',
  redirectIfNotSubscribedTo = '/subscribe',
}) => {
  const location = useLocation();
  const { hasActiveSubscription, determined, isCheckingSubscription } = useSubscription({
    checkOnMount: true,
  });

  // Only hold the spinner during the initial foreground check. Background
  // re-checks (the reconciler) never set isCheckingSubscription, so they don't
  // flip a browsing user back to a spinner.
  if (isCheckingSubscription) {
    return <LoadingSpinner />;
  }

  // Enforce ONLY on an authoritative answer. While entitlement is undetermined
  // (slow/unreachable backend) we fail open and render children so the user can
  // browse; the reconciler keeps checking and this re-renders once we know.
  if (requireSubscription) {
    if (determined && hasActiveSubscription === false) {
      return <Navigate to={redirectIfNotSubscribedTo} state={{ from: location }} replace />;
    }
    return children;
  }

  if (determined && hasActiveSubscription === true) {
    return <Navigate to={redirectIfSubscribedTo} replace />;
  }

  return children;
};

export default SubscriptionGate;
